import * as React from 'react';

import BarChartIcon from '../icons/BarChartIcon';
import DensityIcon from '../icons/DensityIcon';
import PerformanceIcon from '../icons/navIcons/PerformanceIcon';

type IChart = 'lines' | 'bar' | 'spread';

interface IProps extends React.SVGProps<SVGSVGElement> {
    chart: IChart;
}

function ChartIcon({ chart, ref, ...props }: IProps): JSX.Element {
    if (chart === 'lines') {
        return <PerformanceIcon {...props} />;
    } else if (chart === 'bar') {
        return <BarChartIcon {...props} />;
    } else if (chart === 'spread') {
        return <DensityIcon {...props} />;
    } else {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        throw new Error(`Unknown chart: ${chart}`);
    }
}

export default ChartIcon;
